import { ChangeEvent } from 'react';

export const maskHouseNumber = (event: ChangeEvent<HTMLInputElement>) => {
  const matches = event.target.value.replace(/[^a-zA-Z\d\s]/g, '').match(/[1-9]\d{0,4}/);
  if (!matches) return '';

  return matches[0];
};
